import {BellIcon, BookOpenIcon,ChartSquareBarIcon,  AdjustmentsIcon, CalendarIcon } from "@heroicons/react/solid"

export const Menus = [
    { title: "Graficos", src: "Chart_fill", page: "/", img: <ChartSquareBarIcon className="h-6 w-6 fill-white"/>},
    { title: "Configuración", src: "Setting", page: "/setting", img: <AdjustmentsIcon className="h-6 w-6 fill-white"/> },
    { title: "Alertas", src: "bell", page: "/alerts", img: <BellIcon className="h-6 w-6 fill-white"/>},
    { title: "Historico", src: "history", page: "/history", img: <CalendarIcon className="h-6 w-6 fill-white"/> }
]
